import React, { KeyboardEvent, useEffect } from "react";
import { Player } from "@lottiefiles/react-lottie-player";
import authLoader from "@/assets/animations/auth-loader.json";
import styles from "./styles/styled-button.module.scss";

type Props = {
  title: string;
  onClick: () => void;
  outlined?: boolean;
  isLoading?: boolean;
  isDisabled?: boolean;
  keyBind?: string;
  backgroundColor?: string;
  color?: string;
};

const StyledButton = ({
  title,
  onClick,
  isLoading = false,
  isDisabled = false,
  keyBind,
  backgroundColor,
  color,
}: Props) => {
  const onPress = (event: KeyboardEvent) => {
    if (!isDisabled && event.key === keyBind) {
      onClick();
    }
  };

  useEffect(() => () => {
    // @ts-ignore
    document.removeEventListener("keydown", onPress);
  });

  if (keyBind) {
    // @ts-ignore
    document.addEventListener("keydown", onPress);
  }

  return (
    <div
      className={isDisabled ? styles.btn_dis_wrapper : styles.btn}
      onClick={isDisabled ? undefined : onClick}
      role="button"
      tabIndex={0}
      onKeyDown={undefined}
      style={{
        background: backgroundColor ?? "#f9a825",
      }}
    >
      {isLoading ? (
        <Player className={styles.loader} src={authLoader} loop autoplay />
      ) : (
        <div className={styles.btn_title} style={{ color: color ?? "#141414" }}>
          {title}
        </div>
      )}
    </div>
  );
};

export default StyledButton;
